function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { px2rem, getSpacing, getDisplay } from '../../utils/helpers';
var GridColumn = styled('div').withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['offset'].includes(prop) && defaultValidatorFn(prop);
  }
})(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme,
      auto = _ref.auto,
      size = _ref.size,
      offset = _ref.offset,
      order = _ref.order;
  var breakpoints = theme.breakpoints,
      grid = theme.grid;
  var gutters = grid.gutters;

  if (auto) {
    return {
      flex: 1,
      paddingRight: px2rem(gutters / 2),
      paddingLeft: px2rem(gutters / 2)
    };
  }

  var getProperties = function getProperties(bpKey) {
    return {
      flex: size[bpKey] && "0 0 " + size[bpKey] * 100 + "%",
      maxWidth: size[bpKey] && size[bpKey] * 100 + "%",
      order: order && order[bpKey],
      marginLeft: offset && offset[bpKey] && offset[bpKey] * 100 + "%"
    };
  };

  return _extends({
    paddingRight: px2rem(gutters / 2),
    paddingLeft: px2rem(gutters / 2)
  }, getProperties('xs'), (_extends2 = {}, _extends2["@media (min-width: " + breakpoints.small + "px)"] = _extends({}, getProperties('s')), _extends2["@media (min-width: " + breakpoints.medium + "px)"] = _extends({}, getProperties('m')), _extends2["@media (min-width: " + breakpoints.large + "px)"] = _extends({}, getProperties('l')), _extends2["@media (min-width: " + breakpoints.xlarge + "px)"] = _extends({}, getProperties('xl')), _extends2["@media (min-width: " + breakpoints.xxlarge + "px)"] = _extends({}, getProperties('xxl')), _extends2));
}, getSpacing, getDisplay);
GridColumn.propTypes = {
  auto: PropTypes.bool,
  size: PropTypes.shape({}),
  offset: PropTypes.shape({}),
  order: PropTypes.shape({})
};
GridColumn.defaultProps = {
  auto: false,
  size: {
    xs: 1
  },
  offset: undefined,
  order: undefined
};
export default GridColumn;